import _ from 'underscore';
import moment from 'moment';
import CodeModel from '@/models/v5/code';
import Api from '@/lib/api/api';
import Radio from 'backbone.radio';

const alertCh = Radio.channel('alerts');

function update_devicegroup(rel, related_dg) {
    // check for error created when related_dg is null
    if (!related_dg) return false;
    var current_deployment = related_dg.rel && related_dg.rel.get('current_deployment');
    // 'created_at' for new deployments will be null, so we just use 
    // the current date time
    var now = moment(Date.now()).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    if (!current_deployment) {
        current_deployment = this;
    }
    related_dg.rel && related_dg.rel.set('current_deployment', _.max([
        this, current_deployment
    ], function(d) { return moment(d.get('created_at') || now); }));
}
var Deployment = CodeModel.extend({
    initialize: function() {
        this.type = Deployment.type;
        this.listenTo(this.rel, 'change:devicegroup', update_devicegroup);
        // If this already has a related devicegroup set in the relationships
        // make sure that the devicegroup has the most up-to-date deployment
        var related_dg = this.rel.get('devicegroup');
        if (related_dg) update_devicegroup.call(this, this.rel, related_dg);
    },
    get_product: function() {
        return this.rel.get('product');
    },
    get_download_url: function() {
        return this.url() + '?download=true';
    },
    can_download_code: function(devicegroup, primary){
        var globalCh = Radio.channel('global');
        const active =  globalCh.request('active_account');
        primary = primary || globalCh.request('primary_account');
        let can_download_code;

        if (devicegroup && this.get('sha')) {
            switch (devicegroup.type) {
                case devicegroup.TYPES_MAP.development:
                    can_download_code = active.permits(primary, 'view_development_code');
                    break;
                case devicegroup.TYPES_MAP.pre_factoryfixture:
                    can_download_code = active.permits(primary, 'view_pre_factory_code');
                    break;
                case devicegroup.TYPES_MAP.pre_dut:
                    can_download_code = active.permits(primary, 'view_pre_factory_code');
                    break;
                case devicegroup.TYPES_MAP.pre_production:
                    can_download_code = active.permits(primary, 'view_pre_production_code');
                    break;
                case devicegroup.TYPES_MAP.factoryfixture:
                    can_download_code = active.permits(primary, 'view_factory_code');
                    break;
                case devicegroup.TYPES_MAP.dut:
                    can_download_code = active.permits(primary, 'view_factory_code');
                    break;
                case devicegroup.TYPES_MAP.production:
                    can_download_code = active.permits(primary, 'view_production_code');
                    break;
                default:
                    can_download_code = false;
            }
        } else {
            can_download_code = false;
        }
        return can_download_code;
    },
    download: function(){
        const id = this.id;
        const xhr = new XMLHttpRequest();
        const default_headers = Api.getHeaderDefaults();
        xhr.open('GET', this.get_download_url());
        for (let header in default_headers) {
            xhr.setRequestHeader(header, default_headers[header]);
        }
        xhr.onload = function (e) {
            if (this.status == 200) {
                // Create a new Blob object using the response data of the onload object
                var blob = new Blob([this.response], { type: 'application/zip' });
                // Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                let a = document.createElement("a");
                a.style = "display: none";
                document.body.appendChild(a);
                // Create a DOMString representing the blob and point the link element towards it
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = `${id}_code.zip`;
                // programatically click the link to trigger the download
                a.click();
                // release the reference to the file by revoking the Object URL
                window.URL.revokeObjectURL(url);
            } else {
                // deal with your error state here
                alertCh.request('showAlert', {
                    message: 'Error downloading code - do you have permission?',
                    messageType: 'warning',
                    timeout: 0
                });
            }
        };
        xhr.responseType = 'blob';
        xhr.send();
    },
});
Deployment.type = 'deployment';

export default Deployment;

